function openFancybox() {
    $("[data-fancybox]").fancybox({
        video: {
            autoPlay: false,
            autoStart: false,
        }
	});

}
